<div id="social-media" class="works-area pt-100 pb-70">
  <div class="container">
      <div class="section-title text-center">
          <h2>Follow us on Social Media</h2>
      </div>
      <div class="sm-imstagram">
          <app-instagram></app-instagram>
      </div>
  </div>
</div>